import ResponseHandler from './response-handler';
import { MessageTypes } from './message-types'; 
import { settings } from '../settings/settings-util';
import { Reducer } from 'redux';
import { AlmeState } from '../wireup/AlmeState';
import { ResponseActionResponse, Message, AlmeUIResponse } from './response';
import { ResponseAction } from '@alme/types/response/ResponseAction';
import { AlmeResponseV5 } from '@alme/types/response/AlmeResponse';

export default abstract class ResponseActionHandler extends ResponseHandler {
    _responseActionNames: string[] | string[] = [""];
    constructor(validRequestTypes: MessageTypes[], responseActionNames?: string[] | string,
        passedSettings?: typeof settings, reducer?: Reducer<AlmeState>){
        super(validRequestTypes, passedSettings, reducer);
        this.setResponseActionNames(responseActionNames);
    }

    doesHandle(message: Message): boolean{
        return super.doesHandle(message) && this.hasResponseAction(message.response as ResponseActionResponse); 
    }

    setResponseActionNames(responseActionNames: string[] | string = ""): void{
        if (!Array.isArray(responseActionNames)) responseActionNames = [responseActionNames];
        this._responseActionNames = responseActionNames;
    }

    // Return response actions from message
    getResponseActions(responseActionResponse: AlmeUIResponse): ResponseAction[] {
        const response = this.getFirstResponse(responseActionResponse);
        if (!response || !response.responseActions) return [];
        const responseActions = Array.isArray(response.responseActions) ?
            response.responseActions : [];
        const nonNil = (x: ResponseAction): boolean => x != null;
        return responseActions.filter(nonNil);
    }

    // Return first response from response array or a single response if it's not an array
    getFirstResponse(response: AlmeUIResponse): AlmeResponseV5 {
        if(Array.isArray(response)){
            return response[0];
        } else {
            return response as AlmeResponseV5;
        }
    }

    // Return all response actions from the message with the given name(s)
    getResponseActionsNamed(response: AlmeUIResponse): ResponseAction[]{
        return this._responseActionNames?.reduce((actions: ResponseAction[], name: string): ResponseAction[] => [
            ...actions, 
            ...this.getResponseActions(response)
                .filter(ra => ra.Name === name || ra.name === name),
        ], []);
    }

    // Return the first response actions from the message with the given name
    getFirstResponseActionNamed(response: AlmeUIResponse): ResponseAction{
        return this.getResponseActionsNamed(response)[0];
    }

    // Find a matching response action within the message's response actions
    hasResponseAction(response: AlmeUIResponse): boolean{
        const action = this.getFirstResponseActionNamed(response);
        return action != null;
    }

    process(message: Message): Message{
        if (!this.doesHandle(message)) return message;
        if (Array.isArray(message.response)) {
            const response = message.response as Message[];
            response.forEach(item => {
                item.response = this.processResponse(item as AlmeUIResponse);
            });
        }
        else {
            message.response = this.processResponse(message.response as AlmeUIResponse);
        }

        return message;
    }

    abstract processResponse(response: AlmeUIResponse): AlmeUIResponse;
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/types/response-action-handler.ts